import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({ root: { display: 'flex', flexDirection: 'column' } }));
